import React, { useMemo } from 'react';
import { Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';

import { getCOAUrl, ROUTES } from '@futrli/shared-services';
import { UILoader } from '@futrli/ui-components';

import { ChartOfAccountsContainerFr } from './chart-of-accounts-container-fr';
import { ChartOfAccountsContainerUk } from './chart-of-accounts-container-uk';
import { CoaActionsProvider } from './components/context/coa-actions-context';
import { COA_TYPE } from './types';
import { useCoaApiView } from './hooks/useCoaApiView';
import { usePredictManagementContext } from '../predict-management/context/predict-management-context';

export const ChartOfAccountsContainerRouter = () => {
  const { isFrenchAccounting } = usePredictManagementContext();
  const { pathname } = useLocation();

  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisationId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisationId || '';

  const { structure, isLoading, profitAndLossTree, balanceSheetTree } = useCoaApiView(workspaceId, organisationId);

  const displayAccountCodes = structure?.display_codes ?? false;

  const activeTree = useMemo(() => {
    return pathname.indexOf(ROUTES.BALANCE_SHEET) !== -1 ? balanceSheetTree : profitAndLossTree;
  }, [profitAndLossTree, balanceSheetTree, pathname]);

  if (isLoading) {
    return <UILoader isFull />;
  }

  if (!activeTree) {
    return null;
  }

  return (
    <CoaActionsProvider>
      <Routes>
        <Route
          path={ROUTES.PROFIT_AND_LOSS}
          element={
            isFrenchAccounting ? (
              <ChartOfAccountsContainerFr accounts={activeTree.children} displayAccountCodes={displayAccountCodes} />
            ) : (
              <ChartOfAccountsContainerUk
                coaType={COA_TYPE.PROFIT_AND_LOSS}
                displayAccountCodes={displayAccountCodes}
                treeData={activeTree}
              />
            )
          }
        />
        <Route
          path={ROUTES.BALANCE_SHEET}
          element={
            isFrenchAccounting ? (
              <ChartOfAccountsContainerFr accounts={activeTree.children} displayAccountCodes={displayAccountCodes} />
            ) : (
              <ChartOfAccountsContainerUk
                coaType={COA_TYPE.BALANCE_SHEET}
                displayAccountCodes={displayAccountCodes}
                treeData={activeTree}
              />
            )
          }
        />
        <Route
          path="*"
          element={<Navigate to={`${getCOAUrl(workspaceId, organisationId)}${ROUTES.PROFIT_AND_LOSS}`} />}
        />
      </Routes>
    </CoaActionsProvider>
  );
};
